import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import {errorlist} from '../providers/errorlist';

@Component({
  selector: 'app-update-card',
  templateUrl: './update-card.component.html',
  styleUrls: ['./update-card.component.css']
})
export class UpdateCardComponent implements OnInit {

  form: FormGroup;
  pay_type:any = "online";
  card_number: any = [];
  saveCardData:any = [];
  errorlist : any;
  orderData:any;
  currentUser:any = {};

  constructor(private formBuilder: FormBuilder, private auth : AuthService, private router: Router, private spinnerService: Ng4LoadingSpinnerService) { 
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit() {
    this.errorlist = errorlist;

    this.form = this.formBuilder.group({
      expMonth: [null , Validators.required],
      expYear: [null, Validators.required],
      card_number: [null, Validators.required],
      card_type: [null, Validators.required],
      csv: [null, Validators.required],
      save_card_id: [null],
    }, {
      //validator: this.check_atleast_one // your validation method
    });
    this.spinnerService.show();

    let sid = localStorage.getItem('sid');
      this.auth.card_info({"sid":sid}).then((user) => {
        let response = user.json();
        if(response.replyMsg == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          if(response.data.cardData != ""){
            this.saveCardData = response.data;
          }
          this.spinnerService.hide();
        }
      }).catch((err) => {
        this.spinnerService.hide();
        console.log("viiviviiv",err);
        this.auth.open(environment.error)
      });
   }

   onFormSubmit(){
    this.form.controls['expMonth'].markAsTouched();
    this.form.controls['expYear'].markAsTouched();
    this.form.controls['card_type'].markAsTouched();
    this.form.controls['card_number'].markAsTouched();
    this.form.controls['csv'].markAsTouched();
    if(this.form.valid) {
      ///console.log(this.form);return false;
     
        
        
      this.orderData = this.form.value;
      //console.log(this.orderData);
      /* Any API call logic via services goes here */
        
      let sid = localStorage.getItem('sid');
      let area = JSON.parse(localStorage.getItem('currentUser'));
      
      let self = this;
      let addBooking = self.paypal_vault(  function(err, cardResult){
        if(err){
          self.spinnerService.hide();
          self.auth.open(cardResult.replyMsg);
        }else{
          //this.spinnerService.hide();
          let order = {"card_id":"", "cardData":"", "sid":sid};
          if(cardResult.data.RESULT == '0'){
            order.card_id = cardResult.data.PNREF;
            order.cardData = cardResult.data;
            let Booking = self.updateCard(order, self, function(err, bookResult){
              if(err){
                self.spinnerService.hide();
                self.auth.open(bookResult.replyMsg);
              }else{
                console.log("bookResult", bookResult.replyMsg)
                self.spinnerService.hide();
                self.router.navigate(['/my-order']);
              }
            });
          }else{
            self.spinnerService.hide();
            self.auth.open(cardResult.data.RESPMSG);
          }
        }
      });
    }else{
      console.log("FORM NOT VALID", this.form.errors);
    }
   }

  paypal_vault(  callback){
    let sid = localStorage.getItem('sid');
    let index = 0;
    let charcount = 2;
    let expYear = (this.orderData.expYear).substr(0, index) +  (this.orderData.expYear).substr(index + charcount);

    let cardData = {
      "ACCT": this.orderData.card_number,
      "EXPDATE": this.orderData.expMonth+expYear,
      "CVV2": this.orderData.csv,
      "sid":sid
    }
  /*   this.auth.card_save1(cardData).subscribe(success => {
      console.log("hdhdhdh", success)
      callback(false, success);
    }, error => {
      callback(true, error);
      console.log("hdhdhdhdddsssss", error)
    }); */
    this.auth.card_save(cardData).then((save) => {
      console.log("dddd",save);
      let response = save.json();
      if(response.replyCode == "error"){
        callback(true, response);
      }else{
        callback(false, response);
      }
    })
    .catch((err) => {
      console.log(err);
      this.auth.open(err)
    });
  }

  updateCard(data, self1, callback){
    let self = self1;
    self.auth.card_update(data).then((user) => {
      console.log("dddd",user);
      let response = user.json();
      if(response.replyCode == "error"){
        callback(true, response);
      }else{
        callback(false, response);
      }
    })
    .catch((err) => {
      console.log(err);
      self.auth.open(environment.error)
    });
  }

  logout(){
    this.auth.changeLoginStatus(false);
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sid');
    this.router.navigate(['/']);
 }
 
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/update-card/update-card.component.ts